import React from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { IHikingType } from '@apps/Hiking/@types/hiking.types';
import { IGeoRegion } from '@apps/Routes/@services/geo.services';
import {
  addSubscribes,
  getSubscribesPromoInfo,
  requestConfirmSubscribe,
} from '@apps/Users/@services/subscribes.services';
import { selectGeoRegionsSeveralAsync } from '@components/GeoRegionSelector';
import { selectHikingTypesSeveralAsync } from '@components/HikingTypeSelector';
import PageLoader from '@components/PageLoader';
import PohAlert, { AlertVariant } from '@ui-kit/Alert';
import PohInput, { InputTypes } from '@ui-kit/Input';
import PohCol from '@ui-kit/layout/Col';
import PohRow from '@ui-kit/layout/Row';

import styles from './styles.module.css';

const SubscribesCTA = () => {
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaved, setIsSaved] = React.useState(false);
  const [saveError, setSaveError] = React.useState<Error>();

  const [email, setEmail] = React.useState('');
  const [regions, setRegions] = React.useState<IGeoRegion[]>([]);
  const [types, setTypes] = React.useState<IHikingType[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<Error>();
  const [confirmData, setConfirmData] = React.useState<{ confirm: boolean; count: number }>({
    confirm: false,
    count: 0,
  });

  const load = React.useCallback(async () => {
    try {
      setIsLoading(true);
      const { confirm, count } = await getSubscribesPromoInfo();
      setConfirmData({ confirm, count });
    } catch (e) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  if (isLoading) return <PageLoader />;
  if (error) return null;

  if (confirmData.confirm && confirmData.count > 0) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setIsSaving(true);
      const { id } = await addSubscribes({
        email,
        regions: regions.map((d) => d.id),
        types: types.map((d) => d.id),
      });
      await requestConfirmSubscribe(id);
      setIsSaved(true);
    } catch (err) {
      setSaveError(err as Error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <section className={clsx(styles.subscribesWidget)}>
      <PohRow>
        <PohCol sm={4} className={styles.leftSide}>
          <h3>Подпишись</h3>
          <p>И получай анонсы предстоящих походов на почту</p>
        </PohCol>
        <PohCol sm={8} className={styles.rightSide}>
          {isSaved && (
            <div>
              <PohAlert variant={AlertVariant.Success}>
                Почти всё готово. Проверьте email ящик и подтвердите ваш email перейдя по ссылке из
                письма!,
              </PohAlert>
              <hr />
              <p>
                Управляйте вашими подписками в{' '}
                <Link to={'/profile#subscribes'}>личном кабинете</Link>
              </p>
            </div>
          )}
          {!isSaved && (
            <form onSubmit={handleSubmit}>
              <PohInput
                name="email"
                label="E-mail"
                placeholder="yalta89@mail.ru"
                required
                autoFocus
                type={InputTypes.email}
                disabled={isSaving}
                onChange={setEmail}
                value={email}
              />
              <PohInput
                onClick={async () => {
                  const rg = await selectGeoRegionsSeveralAsync({
                    selected: regions.map((d) => d.id),
                    everyoneIsNobody: true,
                  });
                  setRegions(rg);
                }}
                placeholder="Все регионы"
                name="regions"
                label="Регионы"
                disabled={isSaving}
                value={regions.map((r) => r.name).join(', ')}
                title={regions.map((r) => r.name).join(',\n')}
                readOnly
              />

              <PohInput
                onClick={async () => {
                  const rg = await selectHikingTypesSeveralAsync({
                    selected: types.map((d) => d.id),
                    everyoneIsNobody: true,
                  });
                  setTypes(rg);
                }}
                placeholder="Все типы"
                name="types"
                label="Типы"
                disabled={isSaving}
                value={types.map((r) => r.name).join(', ')}
                title={types.map((r) => r.name).join(',\n')}
                readOnly
              />

              <input
                type="submit"
                disabled={isSaving}
                value="Подписаться"
                className="btn btn-danger d-block w-100"
              />
            </form>
          )}
          {saveError && <PohAlert variant={AlertVariant.Danger}>{saveError.message}</PohAlert>}
          {confirmData.count > 0 && (
            <PohAlert variant={AlertVariant.Warning}>
              Мы уже отправили письмо и ждем когда вы перейдете по ссылке
              <br />
              <Link to={'/profile#subscribes'}>подробнее</Link>
            </PohAlert>
          )}
        </PohCol>
      </PohRow>
    </section>
  );
};
export default SubscribesCTA;
